import { render, staticRenderFns } from "./SplashHeader.vue?vue&type=template&id=0cdd5e6c"
import script from "./SplashHeader.vue?vue&type=script&lang=js"
export * from "./SplashHeader.vue?vue&type=script&lang=js"
import style0 from "./SplashHeader.vue?vue&type=style&index=0&id=0cdd5e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports